import React from 'react'
import '../style/Advantages.scss'

export default function Advantages() {
  return (
      <section className="advantages">
          <h2>Ինչո՞վ ենք մենք տարբերվում</h2>
          <div className="adv-grid">
              <div className="adv-item"><span>🌟</span> <h4>Փորձառու մասնագետներ</h4></div>
              <div className="adv-item"><span>🛠️</span> <h4>Գործնական ուսուցում (80%)</h4></div>
              <div className="adv-item"><span>📅</span> <h4>Ճկուն գրաֆիկ</h4></div>
              <div className="adv-item"><span>📜</span> <h4>Պաշտոնական հավաստագիր</h4></div>
          </div>
      </section>
  )
}
